import { render, staticRenderFns } from "./BasicFreqNew.vue?vue&type=template&id=86444212"
import script from "./BasicFreqNew.vue?vue&type=script&lang=js"
export * from "./BasicFreqNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports